import React from 'react';

import { ButtonPrimary } from '@primer/components'


export default function(props) {
  const label = props.isLastQuestion ? 'View summary' : 'Next question'
  return <ButtonPrimary disabled={props.readOnly} className="mt-2" onClick={props.onClick}>{label}</ButtonPrimary>
}
